export interface IInvoiceItemTemplate {
  id?: number;
  title?: string;
  description?: any;
  amount?: number;
  price?: number;
  sorting?: number;
  invoiceInvoiceNumber?: string;
  invoiceId?: number;
}

export const defaultValue: Readonly<IInvoiceItemTemplate> = {};
